/* Prepared Bids search filters reducer */

import * as _ from 'lodash';

import * as Actions from '../actions';
import Auth from '../auth/auth';

export interface ISearchFiltersPreparedBidsState {
    manager: string;
    regionId: any;
    statusId: any;
}

const auth = new Auth();
const initialState: ISearchFiltersPreparedBidsState = {
    manager:  auth.isAdmin() ? auth.getSessionUsername() : '',
    regionId: -1,
    statusId: 0,
};

export function searchFiltersPreparedBidsReducer(state: ISearchFiltersPreparedBidsState = initialState, action: any): ISearchFiltersPreparedBidsState {
    switch (action.type) {
        case Actions.PREPARED_BIDS_FILTER_MANAGER:
            return _.merge({}, state, { manager: action.username });
        case Actions.PREPARED_BIDS_FILTER_STATUS:
            return _.merge({}, state, { statusId: action.statusId });
        case Actions.PREPARED_BIDS_FILTER_REGION:
            return _.merge({}, state, { regionId: action.regionId });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/searchFiltersPreparedBidsReducer.tsx